import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';
import { FpLoggerNoiseAiPredictorChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/services/fp-logger-noise-ai-predictor-chart.service';
import { FpLoggerNoiseAiPredictorConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/services/fp-logger-noise-ai-predictor-connect.service';
import { FpLoggerNoiseAiPredictorExportService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/services/fp-logger-noise-ai-predictor-export.service';
import { FpLoggerNoiseAiPredictorStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/services/fp-logger-noise-ai-predictor/fp-logger-noise-ai-predictor.store';

export function fpLoggerNoiseAiPredictorProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoiseAiPredictorChartService,
    FpLoggerNoiseAiPredictorExportService,
    FpLoggerNoiseAiPredictorStore,
    FpLoggerNoiseAiPredictorConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoiseAiPredictorConnectService,
      multi: true,
    },
  ];
}
